import { apiWrite } from "@/api/client";
import type { ConfirmRefusal } from "@/components/ConfirmDialog";
import {
  doneState,
  errorState,
  type FormState,
  parseFormData,
} from "@/lib/formState";
import { tagUpdateSchema } from "@shared/validation";

export async function updateTagAction(
  slug: string,
  _prevState: FormState,
  formData: FormData,
): Promise<FormState> {
  const parsed = parseFormData(tagUpdateSchema, formData);

  if (!parsed.wasParsed) {
    return parsed.state;
  }

  await apiWrite(`/tags/${slug}`, { method: "PUT", body: parsed.value });

  return doneState("/tags");
}

export async function mergeTagAction(
  loserSlug: string,
  _prevState: FormState,
  formData: FormData,
): Promise<FormState> {
  const survivorSlug = formData.get("survivorSlug");

  if (typeof survivorSlug !== "string" || survivorSlug === "") {
    return errorState({}, { survivorSlug: ["Pick the tag to merge into."] });
  }

  const result = await apiWrite(`/tags/${loserSlug}/merge`, {
    method: "POST",
    body: { survivorSlug },
  });

  if (!result.isOk) {
    // The endpoint answers 422 with the field error already worded, and 404
    // when either slug has gone since the picker rendered.
    return errorState(
      {},
      {
        survivorSlug: result.problem.fieldErrors?.survivorSlug ?? [
          "One of those tags no longer exists.",
        ],
      },
    );
  }

  return doneState("/tags");
}

export async function deactivateTagAction(
  slug: string,
): Promise<ConfirmRefusal> {
  await apiWrite(`/tags/${slug}/deactivate`, { method: "POST" });

  return null;
}

export async function restoreTagAction(slug: string): Promise<void> {
  await apiWrite(`/tags/${slug}/activate`, { method: "POST" });
}
